(function() {
  'use strict';
  
  angular
    .module('app.poll', []);
  
})();